import { useCallback } from 'react';

import { useMutation } from '../hooks';
import { resetSubscriber } from '../api';
import useAuth from './useAuth';

const useResetToken = () => {
  const { setToken } = useAuth();

  const {
    mutate: triggerReset,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: resetSubscriber,
    options: {
      onSuccess: ({ data }) => {
        const token = data.token;
        if (token) {
          setToken(token);
        }
      },
    },
  });

  const resetToken = useCallback(() => {
    triggerReset();
  }, [triggerReset]);

  return {
    resetToken,
    isLoading,
    isSuccess,
  };
};

export default useResetToken;